import { IconWrapper } from '../runtime';
export default IconWrapper('danger', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M8.00015 5.74976V8.24976M2.80399 13.7498H13.1963C14.351 13.7498 15.0727 12.4998 14.4953 11.4998L9.29919 2.49976C8.72184 1.49976 7.27846 1.49975 6.70111 2.49975L1.50496 11.4998C0.927608 12.4998 1.64929 13.7498 2.80399 13.7498Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8 12C8.55229 12 9 11.5523 9 11C9 10.4477 8.55229 10 8 10C7.44772 10 7 10.4477 7 11C7 11.5523 7.44772 12 8 12Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});